import firebase from "firebase/app";

import { getCurrentUser } from "./getCurrentUser";

export const getCurrentDateActivity = async () => {
  const currentUser = getCurrentUser();
  const currentDate = new Date().toISOString().split("T")[0];
  const wantedDocID = currentUser.id + "-" + currentDate;

  if (!currentUser) return null;

  const activityDoc = await firebase.firestore().collection("activities").doc(wantedDocID).get();

  const activityInfo = activityDoc.data();

  if (!activityInfo) return null;

  return {
    ...activityInfo,
    id: activityDoc.id,
  };
};
